<template>
    <slot name="dealsblockcontent" :setDestinationData="setDestinationData" :destinationModalData="destinationModalData"></slot>
</template>

<script setup>
import { ref } from 'vue';

const destinationModalData = ref({});

function setDestinationData(data) {
  destinationModalData.value = data;
}

</script>